import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StarInput, StarsRow } from '../../../components/NewReviewModal';
import { getInfrastructureRating } from '../../../selectors/newReview';
import { setInfrastructureRating } from '../../../actions/newReview';
import { REVIEWS_VALUES } from '../../../constants/reviews';
import { isActive, isHovered } from './utils';

export function InfrastructureRatingContainer() {
  const name = 'infrastructureRating';
  const dispatch = useDispatch();
  const current = useSelector(getInfrastructureRating);
  const [hover, setHover] = React.useState<number | null>(null);

  const setCurrentRating = (value: number) => () => {
    dispatch(setInfrastructureRating(value));
  };

  const onMouseEnter = (value: number) => () => {
    setHover(value);
  };

  const onMouseLeave = () => {
    setHover(null);
  };

  return (
    <StarsRow title="Инфаструктура">
      {REVIEWS_VALUES.map(value => {
        return (
          <StarInput
            isActive={isActive({ value, current })}
            isHover={isHovered({ value, hover })}
            name={name}
            value={value}
            key={`${name}_${value}`}
            onClick={setCurrentRating(value)}
            onMouseEnter={onMouseEnter(value)}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </StarsRow>
  );
}
